import { AnimatePresence } from "framer-motion"
import { Route, Routes, useLocation } from "react-router-dom"
import "./App.css"
import Layout from "./Components/Layout"
import Destination from "./Pages/Destination"
import Home from "./Pages/Home"

function App() {
  const location = useLocation()
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes key={location.pathname} location={location}>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/destination/:titleId" element={<Destination />} />
        </Route>
      </Routes>
    </AnimatePresence>
  )
}

export default App
